/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StandingRow
 */
export interface StandingRow {
    /**
     * 
     * @type {number}
     * @memberof StandingRow
     */
    position?: number;
    /**
     * 
     * @type {string}
     * @memberof StandingRow
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof StandingRow
     */
    teamName?: string;
    /**
     * 
     * @type {number}
     * @memberof StandingRow
     */
    played?: number;
    /**
     * 
     * @type {number}
     * @memberof StandingRow
     */
    won?: number;
    /**
     * 
     * @type {number}
     * @memberof StandingRow
     */
    drawn?: number;
    /**
     * 
     * @type {number}
     * @memberof StandingRow
     */
    lost?: number;
    /**
     * 
     * @type {number}
     * @memberof StandingRow
     */
    goalsFor?: number;
    /**
     * 
     * @type {number}
     * @memberof StandingRow
     */
    goalsAgainst?: number;
    /**
     * 
     * @type {number}
     * @memberof StandingRow
     */
    goalDifference?: number;
    /**
     * 
     * @type {number}
     * @memberof StandingRow
     */
    points?: number;
}

/**
 * Check if a given object implements the StandingRow interface.
 */
export function instanceOfStandingRow(value: object): value is StandingRow {
    return true;
}

export function StandingRowFromJSON(json: any): StandingRow {
    return StandingRowFromJSONTyped(json, false);
}

export function StandingRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): StandingRow {
    if (json == null) {
        return json;
    }
    return {
        
        'position': json['position'] == null ? undefined : json['position'],
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
        'played': json['played'] == null ? undefined : json['played'],
        'won': json['won'] == null ? undefined : json['won'],
        'drawn': json['drawn'] == null ? undefined : json['drawn'],
        'lost': json['lost'] == null ? undefined : json['lost'],
        'goalsFor': json['goalsFor'] == null ? undefined : json['goalsFor'],
        'goalsAgainst': json['goalsAgainst'] == null ? undefined : json['goalsAgainst'],
        'goalDifference': json['goalDifference'] == null ? undefined : json['goalDifference'],
        'points': json['points'] == null ? undefined : json['points'],
    };
}

export function StandingRowToJSON(json: any): StandingRow {
    return StandingRowToJSONTyped(json, false);
}

export function StandingRowToJSONTyped(value?: StandingRow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'position': value['position'],
        'teamId': value['teamId'],
        'teamName': value['teamName'],
        'played': value['played'],
        'won': value['won'],
        'drawn': value['drawn'],
        'lost': value['lost'],
        'goalsFor': value['goalsFor'],
        'goalsAgainst': value['goalsAgainst'],
        'goalDifference': value['goalDifference'],
        'points': value['points'],
    };
}

